import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial?",
  answer: 'Every new account gets free credits to test the platform before committing to a paid plan. You can search local businesses, enrich contacts, and build your first marketing audience — all at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'How do I use local business data for Facebook Ads (Meta Ads)?',
  answer: 'You can export your enriched local business contacts as a CSV file and upload it directly to Facebook Ads Manager (Meta Ads Manager) as a Custom Audience. Meta will match the emails and phone numbers to user profiles, allowing you to serve Facebook Ads directly to local business owners.'
}, {
  question: 'What contact fields are available for local business marketing?',
  answer: 'Openmart provides over 50 data fields per local business. For marketing, the most valuable fields are company_emails, company_phones, owner names, social media profiles, and physical addresses for direct mail.'
}, {
  question: 'How fresh is the local marketing data?',
  answer: 'We continuously crawl, verify, and update our database of millions of local businesses. Records are updated on a weekly basis, ensuring your marketing campaigns do not bounce and reach active businesses.'
}, {
  question: 'Is the local business data GDPR compliant?',
  answer: 'Yes. We only source publicly available business information. For B2B marketing purposes, this data is generally compliant with major privacy regulations when used appropriately for legitimate business interests.'
}, {
  question: 'Can I filter local businesses by specific criteria?',
  answer: 'Absolutely. You can build precise local business audiences by filtering by location (city, state, zip), category, industry, estimated revenue, employee count, and even the technologies they use (tech stack).'
}, {
  question: 'How much does the local business marketing data cost?',
  answer: 'We offer predictable flat pricing based on your usage. You only pay for successful enrichments. Every new account gets free credits to test the platform and build your first local business audience before committing.'
}];
export function MarketingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-4920">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4921">
        <div className="text-center mb-10" data-id="element-4922">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-4923">
            Frequently asked <span className="text-blue-600" data-id="element-4924">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-4925">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-4926">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-4927">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-4928">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-4929" />
                </button>

                <AnimatePresence data-id="element-4930">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-4931">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-4932" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}